<template>
  <v-dialog
    v-model="dialogCall.open"
    @keydown.esc="close"
    persistent
    content-class="small"
  >
    <v-card>
      <v-card-text>
        <v-container class="container">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              Call to <b>{{ dialogCall.name }}</b
              >?
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <div id="error" class="red--text text-center m-l-30 m-r-30">
        {{ dialogCall.errorMessage }}
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="btn-close" class="btn-secondary" @click="close">
          Cancel
        </v-btn>
        <v-btn id="btn-ok" class="btn-primary" @click="onClickCall">
          Call
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import apiChannel from '@/apis/channel'

export default {
  name: 'DialogCall',
  props: {
    dialogCall: Object
  },
  data() {
    return {
      dnis: '3805'
    }
  },
  computed: {
    ...mapGetters('call', ['dialChannelName', 'dialPhoneNumber'])
  },
  methods: {
    ...mapActions('call', [
      'setDialTo',
      'clearDialTo',
      'setDialPhoneNumber',
      'clearDialPhoneNumber',
      'clearDialDtmf',
      'setDialChannelName',
      'clearDialChannelName',
      'setDialIsCalling',
      'setDialIsOpenPanel',
      'clearDialIsShowNumPads'
    ]),
    close() {
      this.dialogCall.open = false
      this.dialogCall._id = ''
      this.dialogCall.name = ''
      this.dialogCall.errorMessage = ''
    },
    onClickCall() {
      const flowId = this.dialogCall._id
      this.setDialChannelName(`webrtc_livecall - ${this.dnis}`)
      this.setDialTo(this.dialogCall.name)
      this.setDialPhoneNumber(this.dnis)
      this.createChannel()
      this.close()
      if (this.dialogCall.from === 'flows') this.openFlowBuilder(flowId)
    },
    startCall() {
      this.close()
      this.setDialIsCalling(true)
      this.setDialIsOpenPanel(true)
      this.clearDialIsShowNumPads()
    },
    cancelCall() {
      this.close()
      this.clearDialChannelName()
      this.clearDialPhoneNumber()
      this.clearDialDtmf()
      this.clearDialTo()
    },
    async createChannel() {
      try {
        const data = {
          name: 'phone',
          channel: { name: this.dialChannelName },
          flow_ui_id: this.dialogCall._id,
          dnis: this.dialPhoneNumber
        }
        const createChannel = await apiChannel.createChannel(data)
        if (createChannel.code === 0) this.startCall()
        else this.cancelCall()
      } catch (err) {
        this.cancelCall()
      }
    },
    openFlowBuilder(flowId) {
      this.$router.push({
        path: `/flows/builder/${flowId}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 80px;
}
</style>
